export const participantRoles = {
  plaintiff: "Plaintiff",
  defendant: "Defendant",
  petitioner: "Petitioner",
  respondent: "Respondent",
  dependent: "Dependent",
  minor_child: "Minor Child",
  witness: "Witness",
  intervenor: "Intervenor",
  other: "Other",
};
export type ParticipantRole =
  (typeof participantRoles)[keyof typeof participantRoles];
